import React from 'react'
import PropTypes from 'prop-types'

import ContentBlock from '../components/ContentBlock'

import localization from '../localization/404'

const NotFoundPage = (props) => {
  const { language } = props

  return (
    <ContentBlock darkBackground>
      <h1 className="t-heading-xl">{localization[language].title}</h1>
    </ContentBlock>
  )
}

NotFoundPage.propTypes = {
  language: PropTypes.string.isRequired,
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js